export default "__VITE_ASSET__Dc2xkVuZ__"